import { Component, Input, OnInit } from '@angular/core';
import { LayoutService } from '@app/layout/layout.service';

interface PriceHistory {
  DocDate: string;
  //orderNumber: number;
  ItemCode: string;
  Dscription: string;
  //quantityOrdered: number;
  //currency: string;
  PriceBefDi: number;
  DiscPrcnt: number;
  Price: number;
  //lineTotal: number;
  //orderStatus: string;
}

@Component({
  selector: 'app-price-history',
  templateUrl: './price-history.component.html',
  styleUrls: ['./price-history.component.less'],
})
export class PriceHistoryComponent implements OnInit {
  @Input() cardCode: string;
  @Input() itemCode: string;
  priceHistory: PriceHistory[] = [];
  isLoading = true;
  error: string | null = null;

  itemDescription: string;
  cardName: string;

  constructor(private layoutService: LayoutService) {}

  ngOnInit(): void {
    this.priceHistory = [];
    this.fetchSalesHistory();
  }

  fetchSalesHistory(): void {
    this.isLoading = true;
    this.layoutService
      .executeQuery(80143, { CardCode: this.cardCode, ItemCode: this.itemCode })
      .subscribe((data: any[]) => {
        this.itemDescription = data.length > 0 ? data[0].Dscription : '';
        this.cardName = data.length > 0 ? data[0].CardName : '';

        this.priceHistory = data;
        this.isLoading = false;
      },
      (error) => {
        this.error = 'Failed to fetch price history';
        this.isLoading = false;
      });
  }
}
